/**
 * Validation constraints and limits for form inputs
 */

// Maximum character length for user-defined names (dimensions, attributes, instances, tags)
export const MAX_INSTANCE_NAME_LENGTH = 256;
